var React = require('react');

function FrontendDropdownMenuApismtp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M0 1v14h16v-14h-16zM15 14h-14v-12h14v12zM14 3h-12v10h12v-10zM7 8h-1v1h-1v1h-1v-1h1v-1h1v-1h-1v-1h-1v-1h1v1h1v1h1v1zM11 10h-3v-1h3v1z"}));
}

FrontendDropdownMenuApismtp.displayName = "FrontendDropdownMenuApismtp";

FrontendDropdownMenuApismtp.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = FrontendDropdownMenuApismtp;

FrontendDropdownMenuApismtp.default = FrontendDropdownMenuApismtp;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/frontend-dropdown-menu-apismtp.svg
// module id = 1014
// module chunks = 0